export const INTERNET_BANK = 'https://ib.moneta.cz'

export const MONETA_BRANCHES = 'https://www.moneta.cz/kontakt/fully-online'

export const MONETA_HOMEPAGE = 'https://moneta.cz'

export const MONETA_LOAN = 'https://www.moneta.cz/pujcky-a-uvery/pujcka-na-cokoliv'

export const MONETA_ACCOUNT = 'https://www.moneta.cz/ucty-a-karty/bezny-ucet'

export const GDPR_MONETA = 'https://www.moneta.cz/ochrana-dat'

export const MONETA_INCOME_FORM =
  'https://www.moneta.cz/documents/cz/pujcky/potvrzeni-o-vysi-prijmu.pdf'

export const MONETA_BUSINESS_LOAN =
  'https://www.moneta.cz/pujcky-a-uvery/business-uver-nezajisteny#uver-section'

export const MONETA_INSURANCE_INFO =
  'https://www.moneta.cz/documents/20143/11819172/mmb-brozura-pojisteni-schopnosti-splacet-uver.pdf'

export const MONETA_IM_LIST = 'https://www.moneta.cz/kontakt/souhlas-aplikace'
